import React from 'react'

interface PDFFileIconProps {
  width?: string
  height?: string
  color?: string
}

const PDFFileIcon: React.FC<PDFFileIconProps> = ({
  width = '8.99824253px',
  height = '12px',
  color = '#00ADE6',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 8.99824253 12"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="popetyio_apps_v3"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="files"
          transform="translate(-25, -116)"
          fill={color}
          fillRule="nonzero"
        >
          <g id="remindercard" transform="translate(12, 109)">
            <g id="Group" transform="translate(13, 7)">
              <path
                d="M8.66783831,2.29642648 L6.70181605,0.330404218 C6.49091974,0.119507909 6.20503808,-1.33330826e-16 5.90743995,-1.33330826e-16 L1.12478032,-1.33330826e-16 C0.50380785,0.00234329233 0,0.506151142 0,1.12712361 L0,10.8752197 C0,11.4961921 0.50380785,12 1.12478032,12 L7.87346221,12 C8.49443468,12 8.99824253,11.4961921 8.99824253,10.8752197 L8.99824253,3.09314587 C8.99824253,2.79554774 8.87873462,2.50732279 8.66783831,2.29642648 Z M7.78207381,3.00175747 L5.99882835,3.00175747 L5.99882835,1.21851201 L7.78207381,3.00175747 Z M1.12478032,10.8752197 L1.12478032,1.12712361 L4.87404804,1.12712361 L4.87404804,3.56414763 C4.87404804,3.87580551 5.12478032,4.12653779 5.4364382,4.12653779 L7.87346221,4.12653779 L7.87346221,10.8752197 L1.12478032,10.8752197 Z M6.98769772,7.50790861 C6.70181605,7.22671353 5.88635032,7.30404218 5.47861746,7.35559461 C5.07557118,7.10954892 4.80609256,6.76977153 4.61628588,6.27065026 C4.70767428,5.8933802 4.85295841,5.31927358 4.74282367,4.95840656 C4.64440539,4.34446397 3.85705917,4.40538957 3.74458114,4.82015231 C3.64147627,5.19742238 3.73520797,5.72231986 3.9086116,6.39250146 C3.67428237,6.95254833 3.32513181,7.70474517 3.07908612,8.13591095 C2.61042765,8.37727006 1.97773872,8.74985354 1.88400703,9.21851201 C1.80667838,9.5887522 2.49326303,10.5120094 3.66725249,8.4874048 C4.19214997,8.31400117 4.7639133,8.10076157 5.27006444,8.01640305 C5.71294669,8.25541886 6.23081429,8.41476274 6.57762156,8.41476274 C7.1751611,8.41476274 7.23374341,7.75395431 6.98769772,7.50790861 Z M2.34563562,9.33099004 C2.46514353,9.00995899 2.91974224,8.6397188 3.05799649,8.51083773 C2.61277094,9.2208553 2.34563562,9.34739309 2.34563562,9.33099004 Z M4.25776216,4.86467487 C4.43116579,4.86467487 4.41476274,5.6168717 4.29994142,5.82073814 C4.19683656,5.4950205 4.19917985,4.86467487 4.25776216,4.86467487 L4.25776216,4.86467487 Z M3.68599883,8.06561219 C3.91329818,7.66959578 4.10779145,7.19859402 4.26479203,6.78383128 C4.4592853,7.13766842 4.70767428,7.4212068 4.97012302,7.61570006 C4.48271822,7.71646163 4.05858231,7.92267135 3.68599883,8.06561219 L3.68599883,8.06561219 Z M6.76977153,7.94844757 C6.76977153,7.94844757 6.65260691,8.08904511 5.89572349,7.76567077 C6.7182191,7.70474517 6.85413005,7.89220855 6.76977153,7.94844757 Z"
                id="Shape"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default PDFFileIcon
